import {
  Box,
  Container,
  Grid,
  List,
  ListItem,
  Typography,
} from "@material-ui/core"
import NextLink from "common/NextLink"
import { useTranslations } from "next-intl"
import styled from "styled-components"
import { MainRoutes } from "~/routes/mainRoutes"
import Description from "../../common/Description"
import { ObjectKeys } from "../../common/utils/iterators"

//Styles

//Styles
const StyledContainer = styled(Container)`
  ${(p) => p.theme.breakpoints.down("sm")} {
    padding: 0;
  }
  ${(p) => p.theme.breakpoints.up("md")} {
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
  }
  padding-bottom: 15px;
`
const StyledContent = styled.div`
  ${(p) => p.theme.breakpoints.down("sm")} {
    padding: 0 16px;
  }

  ${(p) => p.theme.breakpoints.up("md")} {
    padding-top: 84px;
    padding-left: 44px;
    width: 60%;
  }
`

const StyledContentWrapper = styled.div`
  padding: 0 16px;
  margin-top: 30px;
  margin-bottom: 30px;
  ${(p) => p.theme.breakpoints.up("md")} {
    margin-top: 30px;
    padding: 0;
  }
`
const StyledTitle = styled(Typography).attrs({
  component: "h2",
  variant: "h2",
})`
  font-family: "FbJabutinskiEng", "FbJabutinski", sans-serif;
  margin-bottom: 20px;
  margin-top: 0;
  font-size: 16px;
  color: ${(p) => p.theme.colors.red};
  text-decoration: underline;
  letter-spacing: 0;
`

const StyledLinkList = styled(List)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const StyledText = styled(Typography).attrs({ variant: "body1" })`
  font-size: 14px;
  color: ${(p) => p.theme.colors.black};
  text-decoration: underline;
  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 14px;
  }
`
const StyledGridContainer = styled(Grid)`
  margin-top: 20px;
  margin-bottom: 80px;
`
//Types

const SiteMapPage = () => {
  const t = useTranslations("headerMenu")

  const headerOptionsList = [
    "assetsList",
    "investments",
    "relations",
    "general",
    "amot360",
  ] as const

  return (
    <>
      <StyledContainer>
        <StyledContent>
          <Description
            data={{
              title: t("siteMap"),
              subtitle: "",
              description: "",
            }}
          />
          <StyledContentWrapper>
            <NextLink href="/">
              <StyledTitle>{t("homepage")}</StyledTitle>
            </NextLink>
            <StyledGridContainer container spacing={5}>
              {headerOptionsList.map((item) => {
                if (item === "amot360") {
                  return (
                    <Grid item xs={6} md={2} key={item}>
                      <ListItem key={`amot360-0`}>
                        <Box>
                          <NextLink href="/amot360">
                            <StyledTitle>{t("amot360")}</StyledTitle>
                          </NextLink>
                        </Box>
                      </ListItem>
                    </Grid>
                  )
                }
                return (
                  <Grid item xs={6} md={2} key={item}>
                    <StyledTitle>{t(item)}</StyledTitle>
                    <StyledLinkList>
                      {ObjectKeys(MainRoutes[item]).map((key, index) => {
                        return (
                          <ListItem key={`${key}-${index}`}>
                            <Box>
                              <NextLink href={MainRoutes[item][key]}>
                                <StyledText>{t(key)}</StyledText>
                              </NextLink>
                            </Box>
                          </ListItem>
                        )
                      })}
                    </StyledLinkList>
                  </Grid>
                )
              })}
            </StyledGridContainer>
          </StyledContentWrapper>
        </StyledContent>
      </StyledContainer>
    </>
  )
}

export default SiteMapPage
